import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { I18N } from 'commons';
import { clearPosition } from 'utils/ebUtils';

const StateSection = ({
  className,
  setFieldValue,
  values: { state, country },
  states,
  addresseEditable
}) => {
  let fullState = state;
  if (!addresseEditable) {
    states.forEach(item => {
      if (item.value === state) {
        fullState = item.code;
      }
    });
  }
  return (
    <div className={className}>
      <label className="col-form-label" htmlFor="state" id="stateLabel">
        <I18N>ssp.address.state</I18N>
      </label>
      <div>
        {
          addresseEditable && (
            _.isEqual(country, 'US') ? (
              <Field
                component="select"
                name="state"
                id="state"
                className="form-control"
                onChange={e => {
                // set lat & lng empty
                  clearPosition({ setFieldValue, name: 'state', value: e.target.value });
                }}
          // cancel the onblur validation
                onBlur={()=>{}}
              >
                <I18N tag="option" value="">
            ssp.select.null.text
                </I18N>
                {states.map(item => (
                  <option key={`state-${item.value}`} value={item.value}>
                    {item.code}
                  </option>
                ))}
              </Field>
            ) : (
              <Field
                autoComplete="address-level1"
                type="text"
                name="state"
                id="state"
                className="form-control"
                maxLength="40"
                onChange={e => {
                // set lat & lng empty
                  clearPosition({ setFieldValue, name: 'state', value: e.target.value });
                }}
          // cancel the onblur validation
                onBlur={()=>{}}
              />
            )
          )}
        {
          !addresseEditable && (
            <Field
              name="state"
              id="state"
              className="form-control"
              value={fullState}
              readOnly
            />
          )}
      </div>
    </div>
  );
};

StateSection.propTypes = {
  values: PropTypes.shape().isRequired,
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  addresseEditable: PropTypes.bool,
};

StateSection.defaultProps = {
  addresseEditable: false
};

export default StateSection;
